import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { Card, CardBody, Col, Container, Label, Input, Row, FormGroup } from "reactstrap";
import { ToastContainer } from "react-toastify";
import PropTypes from "prop-types";
import ProgressBar from "../../components/ProgressBar";

import "react-toastify/dist/ReactToastify.css";
import "../../styles/login.css";

@inject("loginStore")
@observer
export default class Login extends Component {
  static propTypes = {
    loginStore: PropTypes.object,
    history: PropTypes.object
  };

  logar = event => {
    event.preventDefault();

    this.props.loginStore.logar(this.props.history);
  };

  render() {
    const { loginStore } = this.props;

    return (
      <div className="app app-login flex-row align-items-center">
        <ToastContainer />
        <ProgressBar />

        <Container>
          <Row className="justify-content-center">
            <Col md="4">
              <div className="view-header">
                <div className="header-icon">
                  <i className="pe page-header-icon pe-7s-unlock" />
                </div>
                <div className="header-title">
                  <h3>Login</h3>
                  <small>Por favor, entre com as suas credenciais para logar.</small>
                </div>
              </div>

              <Card className="card-filled">
                <CardBody>
                  <FormGroup>
                    <Label>Login</Label>
                    <Input
                      required
                      type="text"
                      id="login"
                      name="login"
                      placeholder="login"
                      onChange={loginStore.handleChange}
                      value={loginStore.login}
                    />
                    <span className="help-block small">Seu login de acesso</span>
                  </FormGroup>

                  <FormGroup>
                    <Label>Senha</Label>
                    <Input
                      required
                      type="password"
                      id="senha"
                      name="senha"
                      placeholder="********"
                      maxLength={16}
                      onChange={loginStore.handleChange}
                      value={loginStore.senha}
                    />
                    <span className="help-block small">Sua senha de acesso</span>
                  </FormGroup>

                  <div>
                    <button className="btn btn-accent" onClick={this.logar}>
                      Logar
                    </button>{" "}
                    {/* <Link className="btn btn-default" to="/recuperar">
                      Recuperar senha
                    </Link> */}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/autenticacao/Login.js